import { ColumnDescriptorProps } from '../../../../../components/table/ListTable';
import { VinBlacklistModel } from './InterruptionVinUpload';

export const columnDescriptorsLogs = (): ColumnDescriptorProps<VinBlacklistModel>[] => {

    return [
        {
            id: 'listName',
            field: 'listName',
            label: 'VIN Filename',
            format: field => <span>{field}</span>,
        },
        {
            id: 'action-blacklist',
            field: 'action',
            label: 'Action',
            format: field => <span>{field}</span>,
        },
        {
            id: 'requester',
            field: 'requester',
            label: 'Requester',
            format: field => <span>{field}</span>,
        },
        {
            id: 'reason',
            field: 'reason',
            label: 'Reason',
            format: field => <span>{field}</span>,
        },
        {
            id: 'timestamp',
            field: 'timestamp',
            label: 'Creation date',
            format: field => <span>{field}</span>,
        },
    ];
};